import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import Label from "./Label";

import styles from "../Burger.scss";

const cx = classnames.bind(styles);

const BurgerButton = ({
  children,
  counter,
  afterIconName,
  beforeIconName,
  onClick,
  href,
  newTab,
}) =>
  onClick ? (
    <button onClick={onClick} className={cx("burger-button")}>
      <Label
        counter={counter}
        afterIconName={afterIconName}
        beforeIconName={beforeIconName}
      >
        {children}
      </Label>
    </button>
  ) : (
    <a
      href={href}
      target={newTab ? "_blank" : undefined}
      rel={newTab ? "noopener noreferrer" : undefined}
      className={cx("burger-link")}
    >
      <Label
        counter={counter}
        afterIconName={afterIconName}
        beforeIconName={beforeIconName}
      >
        {children}
      </Label>
    </a>
  );

BurgerButton.propTypes = {
  beforeIconName: PropTypes.string,
  afterIconName: PropTypes.string,
  children: PropTypes.node,
  counter: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClick: PropTypes.func,
  href: PropTypes.string,
  newTab: PropTypes.bool,
};

export default BurgerButton;
